import { useCompanyFeatures } from 'app/domains/companies';
import { SearchFiltersToolbar } from 'app/domains/global-search';
import { ActiveFilter, activeFilterLabel, AllowedTeamsFilter, allowedTeamsFilterLabel, AllowedUsersFilter, allowedUsersFilterLabel, AutomaticRenewalFilter, automaticRenewalFilterLabel, ContractCreatorFilter, contractCreatorFilterLabel, ContractOwnerFilter, contractOwnerFilterLabel, CountryFilter, countryFilterLabel, CreatedAtFilter, createdAtFilterLabel, CurrencyFilter, currencyFilterLabel, DateSignedFilter, dateSignedFilterLabel, DeviateFromStandardFilter, deviateFromStandardFilterLabel, DiscountFilter, discountFilterLabel, DocumentCategoryFilter, documentCategoryFilterLabel, DocumentProjectsFilter, documentProjectsFilterLabel, DocumentStartDateFilter, documentStartDateFilterLabel, DocumentStatusFilter, documentStatusFilterLabel, DocumentTypeFilter, documentTypeFilterLabel, EsigningStatusFilter, esigningStatusFilterLabel, FeeAdjustmentClauseFilter, feeAdjustmentClauseFilterLabel, FilesystemPathFilter, fileSystemPathFilterLabel, GoverningLawFilter, governingLawFilterLabel, IndemnityFilter, indemnityFilterLabel, LiabilityCapFilter, liabilityCapFilterLabel, LiabilityCapScopeFilter, liabilityCapScopeFilterLabel, LimitationOfLiabilityFilter, limitationOfLiabilityFilterLabel, MaterialAgreementFilter, materialAgreementFilterLabel, NoticeDateFilter, noticeDateFilterLabel, NoticePeriodDaysFilter, noticePeriodDaysFilterLabel, NoticePeriodMonthsFilter, noticePeriodMonthsFilterLabel, OriginalTermMonthsFilter, originalTermMonthsFilterLabel, OriginalVersionStoredFilter, originalVersionStoredFilterLabel, OutsourcingFilter, outsourcingFilterLabel, PartiesFilter, partiesFilterLabel, PaymentTermsDaysFilter, paymentTermsDaysFilterLabel, PostTerminationObligationsFilter, postTerminationObligationsFilterLabel, ProbationaryPeriodExpirationDateFilter, probationaryPeriodExpirationDateFilterLabel, ProbationaryPeriodFilter, probationaryPeriodFilterLabel, ProcessingOfPersonalDataFilter, processingOfPersonalDataFilterLabel, RenewalTermMonthsFilter, renewalTermMonthsFilterLabel, SearchDocumentTypeFilter, searchDocumentTypeFilterLabel, SharedExternallyFilter, sharedExternallyFilterLabel, TemplateCategoryFilter, templateCategoryFilterLabel, TerminationDateFilter, terminationDateFilterLabel, TerminationForCauseFilter, terminationForCauseFilterLabel, TerminationForConvenienceFilter, terminationForConvenienceFilterLabel, TotalContractCostFilter, totalContractCostFilterLabel, TotalContractValueFilter, totalContractValueFilterLabel, UpdatedAtFilter, updatedAtFilterLabel, } from 'app/domains/insights';
export function DefaultSearchFilters(props) {
    const { filters, actions, exclude = [] } = props;
    const { isFeatureAvailable } = useCompanyFeatures();
    const isProjectsAvailable = isFeatureAvailable('projects');
    const filterItems = [
        {
            id: 'createdByUserId',
            component: ContractCreatorFilter,
            name: contractCreatorFilterLabel(),
        },
        {
            id: 'categoryId',
            component: TemplateCategoryFilter,
            name: templateCategoryFilterLabel(),
        },
        {
            id: 'metadataDocumentType',
            component: SearchDocumentTypeFilter,
            name: searchDocumentTypeFilterLabel(),
        },
        {
            id: 'metadataDocumentStatus',
            component: DocumentStatusFilter,
            name: documentStatusFilterLabel(),
        },
        {
            id: 'metadataDocumentActive',
            component: ActiveFilter,
            name: activeFilterLabel(),
        },
        {
            id: 'metadataDocumentAutomaticRenewal',
            component: AutomaticRenewalFilter,
            name: automaticRenewalFilterLabel(),
        },
        {
            id: 'metadataDocumentDeviateFromStandard',
            component: DeviateFromStandardFilter,
            name: deviateFromStandardFilterLabel(),
        },
        {
            id: 'metadataDocumentMaterialAgreement',
            component: MaterialAgreementFilter,
            name: materialAgreementFilterLabel(),
        },
        {
            id: 'metadataDocumentOutsourcing',
            component: OutsourcingFilter,
            name: outsourcingFilterLabel(),
        },
        {
            id: 'metadataDocumentStartDate',
            component: DocumentStartDateFilter,
            name: documentStartDateFilterLabel(),
        },
        {
            id: 'createdAt',
            component: CreatedAtFilter,
            name: createdAtFilterLabel(),
        },
        {
            id: 'updatedAt',
            component: UpdatedAtFilter,
            name: updatedAtFilterLabel(),
        },
        {
            id: 'metadataDocumentDateSigned',
            component: DateSignedFilter,
            name: dateSignedFilterLabel(),
        },
        {
            id: 'metadataDocumentNoticeDate',
            component: NoticeDateFilter,
            name: noticeDateFilterLabel(),
        },
        {
            id: 'metadataDocumentTerminationDate',
            component: TerminationDateFilter,
            name: terminationDateFilterLabel(),
        },
        {
            id: 'metadataDocumentContractOwner',
            component: ContractOwnerFilter,
            name: contractOwnerFilterLabel(),
        },
        {
            id: 'metadataDocumentParties',
            component: PartiesFilter,
            name: partiesFilterLabel(),
        },
        {
            id: 'metadataDocumentCurrency',
            component: CurrencyFilter,
            name: currencyFilterLabel(),
        },
        {
            id: 'metadataDocumentDocumentCategory',
            component: DocumentCategoryFilter,
            name: documentCategoryFilterLabel(),
        },
        {
            id: 'metadataDocumentDocumentType',
            component: DocumentTypeFilter,
            name: documentTypeFilterLabel(),
        },
        {
            id: 'metadataDocumentEsigningStatus',
            component: EsigningStatusFilter,
            name: esigningStatusFilterLabel(),
        },
        {
            id: 'metadataDocumentGoverningLaw',
            component: GoverningLawFilter,
            name: governingLawFilterLabel(),
        },
        {
            id: 'metadataDocumentCountry',
            component: CountryFilter,
            name: countryFilterLabel(),
        },
        {
            id: 'metadataDocumentIsSharedExternally',
            component: SharedExternallyFilter,
            name: sharedExternallyFilterLabel(),
        },
        {
            id: 'metadataDocumentNoticePeriodDays',
            component: NoticePeriodDaysFilter,
            name: noticePeriodDaysFilterLabel(),
        },
        {
            id: 'metadataDocumentNoticePeriodMonths',
            component: NoticePeriodMonthsFilter,
            name: noticePeriodMonthsFilterLabel(),
        },
        {
            id: 'metadataDocumentOriginalTermMonths',
            component: OriginalTermMonthsFilter,
            name: originalTermMonthsFilterLabel(),
        },
        {
            id: 'metadataDocumentOriginalVersionStored',
            component: OriginalVersionStoredFilter,
            name: originalVersionStoredFilterLabel(),
        },
        {
            id: 'metadataDocumentRenewalTermMonths',
            component: RenewalTermMonthsFilter,
            name: renewalTermMonthsFilterLabel(),
        },
        {
            id: 'metadataDocumentTotalContractCost',
            component: TotalContractCostFilter,
            name: totalContractCostFilterLabel(),
        },
        {
            id: 'metadataDocumentTotalContractValue',
            component: TotalContractValueFilter,
            name: totalContractValueFilterLabel(),
        },
        {
            id: 'metadataDocumentProcessingOfPersonalData',
            component: ProcessingOfPersonalDataFilter,
            name: processingOfPersonalDataFilterLabel(),
        },
        {
            id: 'metadataDocumentLiabilityCapScope',
            component: LiabilityCapScopeFilter,
            name: liabilityCapScopeFilterLabel(),
        },
        {
            id: 'metadataDocumentDiscount',
            component: DiscountFilter,
            name: discountFilterLabel(),
        },
        {
            id: 'metadataDocumentFeeAdjustmentClause',
            component: FeeAdjustmentClauseFilter,
            name: feeAdjustmentClauseFilterLabel(),
        },
        {
            id: 'metadataDocumentIndemnity',
            component: IndemnityFilter,
            name: indemnityFilterLabel(),
        },
        {
            id: 'metadataDocumentLiabilityCap',
            component: LiabilityCapFilter,
            name: liabilityCapFilterLabel(),
        },
        {
            id: 'metadataDocumentLimitationOfLiability',
            component: LimitationOfLiabilityFilter,
            name: limitationOfLiabilityFilterLabel(),
        },
        {
            id: 'metadataDocumentPaymentTermsDaysFromInvoiceDate',
            component: PaymentTermsDaysFilter,
            name: paymentTermsDaysFilterLabel(),
        },
        {
            id: 'metadataDocumentPostTerminationObligations',
            component: PostTerminationObligationsFilter,
            name: postTerminationObligationsFilterLabel(),
        },
        {
            id: 'metadataDocumentProbationaryPeriod',
            component: ProbationaryPeriodFilter,
            name: probationaryPeriodFilterLabel(),
        },
        {
            id: 'metadataDocumentProbationaryPeriodExpirationDate',
            component: ProbationaryPeriodExpirationDateFilter,
            name: probationaryPeriodExpirationDateFilterLabel(),
        },
        {
            id: 'metadataDocumentTerminationForCause',
            component: TerminationForCauseFilter,
            name: terminationForCauseFilterLabel(),
        },
        {
            id: 'metadataDocumentTerminationForConvenience',
            component: TerminationForConvenienceFilter,
            name: terminationForConvenienceFilterLabel(),
        },
        {
            id: 'metadataDocumentProjectIds',
            component: DocumentProjectsFilter,
            name: documentProjectsFilterLabel(),
            exclude: !isProjectsAvailable,
        },
        {
            id: 'metadataEntryPath',
            component: FilesystemPathFilter,
            name: fileSystemPathFilterLabel(),
            exclude: true,
        },
        {
            id: 'allowedUsers',
            component: AllowedUsersFilter,
            name: allowedUsersFilterLabel(),
        },
        {
            id: 'allowedTeams',
            component: AllowedTeamsFilter,
            name: allowedTeamsFilterLabel(),
        },
    ];
    return <SearchFiltersToolbar actions={actions} filters={filters} filterItems={filterItems} exclude={exclude}/>;
}
